import {observer} from "mobx-react";
import {Pie, PieChart, PieSectorShapeProps, ResponsiveContainer, Sector, Tooltip} from "recharts";
import {TooltipContent} from "./TooltipContent";
import {kpiRepositoryStore} from "../../../store";
import {useEffect, useState} from "react";
import {DataStateDto} from "../../../api/kpi";

const colors = [
    '#82ca9d',  /* Grün */
    '#ffc658',  /* Gelb */
    '#83a6ed',  /* Hellblau */
    '#8dd1e1',  /* Cyan */
    '#ff8040',  /* Orange */
    '#ff6b6b',  /* Koralle/Rot */
    '#fd79a8',  /* Pink */
    '#8884d8',  /* Violettblau */
]

const keys = [
    "CONTRACT",
    "SALARY_STATEMENT",
    "ID_CARD",
    "OTHER",
    "COR_I",
    "COR_II",
    "COC",
    "ABE",
    "CERT",
    "ENVELOPE",
    "COVER_LETTER",
    "CAR_KEY",
    "RADIO_CODE",
    "WARRANTY",
    "LICENSE_PLATE_FRONT",
    "LICENSE_PLATE_REAR",

    "INITIALIZED",
    "STORED",
    "RELEASE_PREPARED",
    "RELEASED",
]

const namedColors: Record<string, string> = {}

keys.forEach((key, index) => {
    namedColors[key] = colors[index % colors.length]
})

function getColor(payload: any, index: number): string {
    const state = payload?.state
    const type = payload?.type

    if (type && namedColors[type]) {
        return namedColors[type]
    }

    if (state && namedColors[state]) {
        return namedColors[state]
    }
    return colors[index % colors.length]
}

const MyCustomPie = (props: PieSectorShapeProps) => {
    const color = getColor(props.payload, props.index)
    return <Sector {...props} fill={color}/>;
};

const Repository = observer(function Repositor() {
    const stateCountOrigin = kpiRepositoryStore.stateCount
    const storedCountOrigin = kpiRepositoryStore.storedCount
    const storedCountByType = kpiRepositoryStore.storedCountByType
    const totalOrigin = kpiRepositoryStore.total

    const [total, setTotal] = useState<Record<string, unknown>[]>([])
    const [stateCount, setStateCount] = useState<Record<string, unknown>[]>([])
    const [storedCount, setStoredCount] = useState<Record<string, unknown>[]>([])
    const [typeStateCount, setTypeStateCount] = useState<Record<string, unknown>[]>([])

    useEffect(() => {
        setTotal(JSON.parse(JSON.stringify([{name: 'Total', value: totalOrigin}])))
    }, [totalOrigin]);

    useEffect(() => {
        setStateCount(JSON.parse(JSON.stringify(stateCountOrigin)))
    }, [stateCountOrigin]);

    useEffect(() => {
        setStoredCount(JSON.parse(JSON.stringify([{name: 'Eingelagert', value: storedCountOrigin, state: DataStateDto.STORED}])))
    }, [storedCountOrigin]);

    useEffect(() => {
        setTypeStateCount(JSON.parse(JSON.stringify(storedCountByType)))
    }, [storedCountByType]);

    return <>
        <div className="card">
            <header className="card-header">
                <p className="card-header-title">Archiv</p>
            </header>
            <div style={{height: '22.4em', display: 'flex'}}>
                <ResponsiveContainer>
                    <PieChart responsive={true}>

                        <Pie
                            stroke="none"
                            isAnimationActive={true}
                            data={total}
                            dataKey={"value"}
                            nameKey={"name"}
                            cx="50%"
                            cy="50%"
                            innerRadius="0%"
                            outerRadius="15%"
                            fill="#004b78"
                        />

                        <Pie
                            stroke="none"
                            shape={MyCustomPie}
                            isAnimationActive={true}
                            data={stateCount}
                            dataKey={"value"}
                            nameKey={"name"}
                            cx="50%"
                            cy="50%"
                            innerRadius="16%"
                            outerRadius="45%"
                            fill="#FFBB28"
                        />
                        <Pie
                            stroke="none"
                            shape={MyCustomPie}
                            isAnimationActive={true}
                            data={storedCount}
                            dataKey={"value"}
                            nameKey={"name"}
                            cx="50%"
                            cy="50%"
                            innerRadius="45%"
                            outerRadius="60%"
                            fill="#0cc"
                        />
                        <Pie
                            stroke="none"
                            shape={MyCustomPie}
                            isAnimationActive={true}
                            data={typeStateCount}
                            dataKey={"value"}
                            nameKey={"name"}
                            cx="50%"
                            cy="50%"
                            innerRadius="61%"
                            outerRadius="95%"
                            fill="#0cc"
                        />

                        <Tooltip content={TooltipContent}/>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    </>
})

export {
    Repository
}
